import React, {memo} from 'react';

const DissolutionWarning = () => {
  return (
    <p>
      Estás a punto de marcar la empresa como &quot;En Proceso de Disolución&quot;. Esta acción es significativa y
      podría tener consecuencias legales y financieras.
    </p>
  );

};

export default memo(DissolutionWarning);
